module.exports = __webpack_public_path__ + "static/media/Level_4.6bc18d36.png";